import React from 'react'
import ManageCenterContent from "../components/ManageCenter/ManageCenterContent";

  
class ManageCenter extends React.Component
{
    
    render() {

        
    

        return(
            <div>
                <ManageCenterContent/>
            </div>
        );
    }
}
export default ManageCenter;


// WEBPACK FOOTER //
// ./src/pages/ManageCenter.js